<div class="blackout-time-dropdown" [attr.data-testid]="testIdPrefix">
  <div class="blackout-dropdown-selects">
    <div class="select is-small">
      <select
        [disabled]="disabled"
        [(ngModel)]="hour"
        (ngModelChange)="onChange()"
        [attr.data-testid]="testIdPrefix + '-hour'"
        [attr.aria-label]="(ariaLabel ? ariaLabel + ' ' : '') + 'hour'"
       data-ui-name="Hour" data-ui-component="blackout-time-dropdown">
        <option *ngFor="let h of BLACKOUT_HOUR_OPTIONS" [ngValue]="h" data-ui-name="H — hour" data-ui-component="blackout-time-dropdown" data-testid="blackout-time-dropdown-h-hour">{{ h }}</option>
      </select>
    </div>
    <span class="blackout-time-colon">:</span>
    <div class="select is-small">
      <select
        [disabled]="disabled"
        [(ngModel)]="minute"
        (ngModelChange)="onChange()"
        [attr.data-testid]="testIdPrefix + '-minute'"
        [attr.aria-label]="(ariaLabel ? ariaLabel + ' ' : '') + 'minute'"
       data-ui-name="Minute" data-ui-component="blackout-time-dropdown">
        <option *ngFor="let m of BLACKOUT_MINUTE_OPTIONS" [ngValue]="m" data-ui-name="M — minute" data-ui-component="blackout-time-dropdown" data-testid="blackout-time-dropdown-m-minute">{{ m }}</option>
      </select>
    </div>
  </div>
</div>
